<template>
  <main class="w-100">
    <LoadingSpinner v-if="!completeLoading" />
    <div v-else class="mx-2">
      <div class="card p-2 mb-2 text-left">
        <p>
          <strong>Zapmail Wallet Balance:</strong>
          <strong :class="walletBalance < 300 ? 'badge badge-danger ml-2' : 'badge badge-success ml-2'">$ {{ walletBalance }}</strong>
        </p>
        <p>
          <strong>Microsoft Unassigned Mailboxes ({{ PlanType }} Plan):</strong>
          <strong :class="microsoftUnassigned < 36 ? 'badge badge-danger ml-2' : 'badge badge-success ml-2'">{{ microsoftUnassigned }}</strong>
        </p>
      </div>
      <div class="col-md-12 card p-2">
        <table class="table table-striped" :key="domainhttpsindex">
          <thead class="thead-dark">
            <td></td>
            <td></td>
            <td>
              <strong>Client Id</strong>
            </td>
            <td>
              <strong>Client</strong>
            </td>
            <td>
              <strong>Client Status</strong>
            </td>
            <td>
              <strong>Sales</strong>
            </td>
            <td>
              <strong>Sales status</strong>
            </td>
          </thead>
          <tbody>
            <tr v-for="(row, index) in list" :key="index">
              <td>
                {{ index + 1 }}
              </td>
              <td>
                <span
                  v-if="row.task_open_hours !== null"
                  class="badge"
                  :class="taskOpenHoursClass(row.task_open_hours)"
                >
                  {{ row.task_open_hours }} h
                </span>
              </td>
              <td>{{ row.client_id }}</td>
              <td>
                <span class="text-primary cursor-pointer">
                  <a :href="'/clients/' + row.client_id" target="_blank">
                    {{ row.name }}
                  </a>
                </span>
              </td>
              <td>{{ row.client_status }}</td>
              <td>{{ row.last_name }}, {{ row.first_name }}</td>
              <td>{{ capitalizeFirstLetter(row.sale_status) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </main>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { workspaceService } from "@/_services";

export default {
  name: "AgencyBuyDomain",
  components: {
    LoadingSpinner,
  },
  props: {
    condition: {
      type: String,
      default: "all",
    },
  },
  computed: {
    capitalizeFirstLetter() {
      return (word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      };
    },
  },
  data() {
    return {
      completeLoading: false,
      list: [],
      domainhttps: [],
      domaindns: [],
      domainhttpsindex: 32322332,
      microsoftUnassigned: null,
      walletBalance: null,
      PlanType: null,
    };
  },

  created() {
    this.getCalendarDomains();
    this.getDataUserZapmailDetails();
  },
  methods: {
    getCalendarDomains() {
      this.completeLoading = false;
      workspaceService.getDomainsToBuy().then((result) => {
        this.list = result;
        this.completeLoading = true;
      });
    },
    getDataUserZapmailDetails(){
      this.completeLoading = false;
      workspaceService.getUserZapmailDetails().then((result) => {
        this.microsoftUnassigned = result.MICROSOFT.purchasedMailboxes - result.MICROSOFT.assignedMailboxes;
        this.walletBalance = result.GOOGLE.walletBalance;
        this.PlanType = result.MICROSOFT.activePlan;
        this.completeLoading = true;
      });
    },
    taskOpenHoursClass(task_open_hours) {
      if (task_open_hours < 12) {
        return "badge-warning";
      }
      return "badge-danger";
    },
  },
};
</script>
